import axios from '../utils/axios';

export const createPatientServicePackage = (patientId: string, servicePackageId: string) => {
  return axios.post(`/api/v1/servicepackages/patient`, {
    patientId,
    servicePackageId,
  });
};
